<template>
  <div id="app">
    <a
      class="logo"
      href="https://www.mirrormedia.mg/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="./assets/logo.svg" alt="鏡週刊 Mirror Media">
    </a>
    <AppIndex />
    <AppIntro />
    <AppArticle />
    <AppCredit />
  </div>
</template>

<script>

import './base.css'

import AppArticle from './components/AppArticle.vue'
import AppCredit from './components/AppCredit.vue'
import AppIndex from './components/AppIndex.vue'
import AppIntro from './components/AppIntro.vue'

export default {
  name: 'app',
  components: {
    AppArticle,
    AppCredit,
    AppIndex,
    AppIntro
  }
}
</script>

<style lang="scss">
#app {
  font-family: -apple-system, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.87);
}

body {
  overflow-x: hidden !important;
}

p {
  font-size: 15px;
  line-height: 2;
  & + p {
    margin-top: 2em;
  }
}

.logo {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 900;
}
</style>
